import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import * as SS from 'styled-system';

const MUI_SVG_ICON_COLORS = new Set([
  'inherit',
  'primary',
  'secondary',
  'action',
  'error',
  'disabled'
]);

const MUI_SVG_ICON_FONT_SIZES = new Set(['inherit', 'default', 'small', 'large']);

export interface IconProps extends SS.SpaceProps, SS.LayoutProps, SS.FontSizeProps {
  Component: React.ElementType;
  color?: string;
}

export const Icon = styled(
  ({ Component, color, fontSize, ...props }: IconProps) => {
    // MUI SvgIcon solo acepta palette / size keys; el resto va por CSS (styled-system).
    const muiColor =
      color != null && MUI_SVG_ICON_COLORS.has(color) ? color : ('inherit' as const);
    const muiFontSize =
      fontSize != null &&
      typeof fontSize === 'string' &&
      MUI_SVG_ICON_FONT_SIZES.has(fontSize)
        ? fontSize
        : undefined;

    return <Component color={muiColor} fontSize={muiFontSize} {...props} />;
  }
)`
  font-size: ${rem('20px')};
  fill: currentColor;
  color: ${props => props.color ?? props.theme.colors.S[800]};
  ${SS.space}
  ${SS.fontSize}
  ${SS.layout}
`;
